import type { MachineContext } from '../ResolutionFlow.machine.types'

export function getPreviousPage({ pageHistory }: MachineContext) {
  return pageHistory[pageHistory.length - 1]
}
